var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrpCls},[_c('div',{staticClass:"btn-fullscreen",class:_vm.prefixCls,on:{"click":_vm.handleFullScreen}},[_c('a-icon',{attrs:{"type":"fullscreen"}})],1),_c('avatar-dropdown',{class:_vm.prefixCls,attrs:{"menu":_vm.showMenu,"current-user":_vm.currentUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }